import { Box, Rating, Typography } from "@mui/material";
import { grey, orange } from "@mui/material/colors";

import BrandSocialLinks from "features/Influencer/Discover/Shared/BrandSocialLinks";

import { BrandSearchResult } from "..";

export default function BrandHeader({ brand }: { brand: BrandSearchResult }) {
  const cleanWebsite = (website: string) => {
    return website
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .replace(/\?.*$/, "")
      .replace(/\/$/, "");
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 700,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {brand.name}
      </Typography>
      <Box sx={{ mb: 0.5 }}>
        {(brand.instagram_username || brand.website) && (
          <BrandSocialLinks
            instagramUsername={brand.instagram_username || undefined}
            bentoBrandId={
              brand.source === "database"
                ? Number(brand.bento_brand_id)
                : undefined
            }
            website={brand.website ? cleanWebsite(brand.website) : undefined}
          />
        )}
      </Box>
      {!!brand.description && !brand.address && (
        <Typography color="textSecondary" sx={{ fontSize: 12 }} paragraph>
          {brand.description}
        </Typography>
      )}
      {!!brand.rating && (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Rating
            name="read-only"
            value={brand.rating}
            precision={0.1}
            color="primary"
            readOnly
            icon={
              <Box
                component="span"
                className="fa-solid fa-star"
                sx={{ fontSize: 12 }}
              />
            }
            emptyIcon={
              <Box
                component="span"
                className="fa-solid fa-star"
                sx={{ fontSize: 12 }}
              />
            }
            sx={{
              "& .MuiRating-iconFilled": {
                color: orange[200],
              },

              "& .MuiRating-iconEmpty": {
                color: grey[300],
              },
            }}
            size="small"
          />
          <Typography
            sx={{
              color: grey[700],
              fontSize: 12,
            }}
            color="textSecondary"
          >
            ({brand.user_rating_count})
          </Typography>
        </Box>
      )}
      {brand.address && (
        <Typography
          color="textSecondary"
          paragraph
          sx={{
            color: grey[700],
            fontSize: 12,
            textTransform: "capitalize",
          }}
        >
          {!!brand.description && `${brand.description} · `}
          {brand.address}
        </Typography>
      )}
    </>
  );
}
